import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import useLineLiff from 'hooks/LineLiff';
import { AuthValid } from 'shared/httpHandler';
import { encodeBase64Object } from 'shared/common';

import 'pages/toyotaOfficialAccount/toyota-namespace.css';
import Loading from 'pages/toyotaOfficialAccount/Loading';
import Error from 'pages/toyotaOfficialAccount/Error';

import axios from 'axios';

const RedirectPage = () => {
  const [searchParams] = useSearchParams();
  const [displayError, setDisplayError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const { userInfo } = useLineLiff(process.env.REACT_APP_LIFF_ID_REDIRECT);

  const executeRedirect = async (token, uuid, tagMapName) => {
    try {
      const queryParams = new URLSearchParams(
        encodeBase64Object({
          line_user_id: userInfo.userId,
          uuid: uuid,
          tag_map_name: tagMapName,
          auth_token: token,
        })
      );

      const response = await axios.get(
        `${
          process.env.REACT_APP_BASE_URL
        }/liff_redirect/redirect_url?${queryParams.toString()}`
      );

      console.log('Redirect URL:', response.data.data.url);
      window.location.href = response.data.data.url;
    } catch (error) {
      console.error('Error fetching redirect URL:', error);

      if (error.status >= 400 && error.status <= 499) {
        setErrorMessage('您正前往的頁面已失效，請重新操作LINE官方帳號選單。');
        setDisplayError(true);
        return;
      }

      setErrorMessage('系統忙碌中，請稍後再試。');
      setDisplayError(true);
    }
  };

  useEffect(() => {
    if (!userInfo) return;

    const token = searchParams.get('token');

    if (token) {
      try {
        const payload = AuthValid.parseJwt(token);
        const uuid = payload.uuid || null;
        const tagMapName = payload.tag_map_name || null;
        executeRedirect(token, uuid, tagMapName);
        return;
      } catch (error) {
        console.error('Error parsing JWT:', error);
      }
    }

    setErrorMessage('您正前往的頁面已失效，請重新操作LINE官方帳號選單。');
    setDisplayError(true);
  }, [userInfo]);

  if (displayError) {
    return <Error message={errorMessage} />;
  }

  return <Loading />;
};

export default RedirectPage;
